import * as React from 'react';
import * as classNames from 'classnames';
import { Link, LinkProps } from 'react-router-dom';
import './style.css';

export interface LinkButtonProps extends LinkProps {
  /* empty */
}

export interface LinkButtonState {
  /* empty */
}

export class LinkButton extends React.Component<
  LinkButtonProps,
  LinkButtonState
> {
  render() {
    return (
      <Link
        {...this.props}
        className={classNames(
          'edge-of-play-link edge-of-play-button-link',
          this.props.className
        )}
      />
    );
  }
}

export default LinkButton;



// WEBPACK FOOTER //
// ./src/app/components/Common/LinkButton/index.tsx